// extracted by mini-css-extract-plugin
module.exports = {"alert":"Footer_alert__3oUAg"};